export default "__VITE_ASSET__Cyxq6RXd__"